var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7028 30.4571L23.7027 30.4571L23.6978 30.4586C23.4336 30.5392 23.1235 30.5016 22.8598 30.349L22.8459 30.341L22.8315 30.3339L12.7065 25.3121L12.4845 25.202L12.2625 25.3119L2.12186 30.3337L2.12179 30.3336L2.11101 30.3393C1.93525 30.4317 1.74751 30.4833 1.57812 30.4833C0.981873 30.4833 0.5 29.9968 0.5 29.4024V5.87427C0.5 3.92546 1.28265 2.61475 2.52697 1.76985C3.79913 0.90605 5.60027 0.5 7.65625 0.5H17.2969C19.3606 0.5 21.1621 0.906042 22.4384 1.77022C23.687 2.61565 24.4776 3.92764 24.5 5.87713V29.4024C24.5 29.5875 24.456 29.7684 24.3729 29.9236C24.2338 30.1774 23.9982 30.3703 23.7028 30.4571ZM18.3594 8.86164H6.59375C5.64538 8.86164 4.875 9.62832 4.875 10.5861C4.875 11.5419 5.64497 12.3105 6.59375 12.3105H18.3594C19.3082 12.3105 20.0781 11.5419 20.0781 10.5861C20.0781 9.62832 19.3077 8.86164 18.3594 8.86164Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave2);
export default __webpack_public_path__ + "static/media/save 2.27707a89cbeee87228e1dcf95d77cb3c.svg";
export { ForwardRef as ReactComponent };